import React from 'react';
import { StyledTriangledArrow } from './labelled-arrow.style';

interface IProps {
    left?: boolean;
    right?: boolean;
    backgroundColor: string;
    textColor?: string;
    heightBox: number;
    children: React.ReactNode;
}

export const LabelledArrow = (props: IProps) => {
    const { left, right, backgroundColor, textColor, heightBox } = props;
    return (
        <StyledTriangledArrow
            leftTriangle={left}
            rightTriangle={right}
            heightBox={heightBox}
            backgroundColor={backgroundColor}
            textColor={textColor}
            data-testid="triangled-arrow"
        >
            {props.children}
        </StyledTriangledArrow>
    );
};
